<template>
    <div class="page">
      <v-container fluid>
        <v-form ref="form">
          <v-row class="justify-center mt-3">
            <v-col cols="3">
              <v-text-field
                label="Nome da Disciplina"
                v-model="form.filters.nomeDisciplina"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-autocomplete
                v-model="form.filters.tipoDisciplina"
                :items="form.lists.tiposDeDisciplina"
                label="Tipo de Disciplina"
                item-text="tipoDisciplina"
                item-value="id"
                outlined
                dense
              ></v-autocomplete>
            </v-col>
            <sigfoco-select-ativo
              :cols="3"
              v-model="form.filters.ativo"
              labelType="Situação"
            ></sigfoco-select-ativo>
          </v-row>
          <div class="text-center">
            <v-col cols="12">
              <sigfoco-tooltip
                text="Buscar"
                icon="mdi-magnify"
                @click="buscarDisciplina()"
              ></sigfoco-tooltip>
              <sigfoco-tooltip
                text="Limpar"
                icon="mdi-eraser"
                @click="resetForm()"
              ></sigfoco-tooltip>
              <sigfoco-tooltip
                text="Incluir"
                icon="mdi-plus"
                @click="openDialogManterDisciplina()"
              ></sigfoco-tooltip>
            </v-col>
          </div>
        </v-form>
        <v-data-table
          class="mt-5"
          :headers="headers"
          :items="form.lists.listDisciplinas"
          :items-per-page="10"
          :footer-props="$footerProps"
        >
          <template v-slot:[`item.nomeDisciplina`]="{ item }">
            {{ item.nomeDisciplina }}
          </template>
          <template v-slot:[`item.tipoDisciplina`]="{ item }">
            {{ item.tipoDisciplina }}
          </template>
          <template v-slot:[`item.ativo`]="{ item }">
            <sigfoco-label-ativo-inativo :ativo="item.ativo"></sigfoco-label-ativo-inativo>
          </template>
          <template v-slot:[`item.acoes`]="{ item }">
            <sigfoco-tooltip
              text="Visualizar Disciplina"
              icon="mdi-eye-outline"
              small
              @click="openDialogVisualizarDisciplina(item)"
            ></sigfoco-tooltip>
            <sigfoco-tooltip
              text="Editar Disciplina"
              icon="mdi-pencil"
              small
              @click="openDialogManterDisciplina(item)"
            ></sigfoco-tooltip>
            <sigfoco-tooltip
              text="Excluir Disciplina"
              icon="mdi-delete"
              small
              @click="exclusaoDisciplina(item)"
            ></sigfoco-tooltip>
            <sigfoco-tooltip
              :text="`${item.ativo ? 'Inativar Disciplina' : 'Ativar Disciplina'}`"
              :icon="`${item.ativo ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off'}`"
              :color="`${item.ativo ? 'var(--primary-button-color)' : 'silver'}`"
              small
              @click="alterarStatusDisciplina(item)"
            ></sigfoco-tooltip>
          </template>
          <template v-slot:[`item.emUso`]="{ item }">
          <sigfoco-tooltip
            :text="'Detalhar Uso'"
            :icon="item.emUso ? 'mdi-check-circle-outline' : 'mdi-close-circle-outline'"
            :color="item.emUso ? 'green' : 'red'"
            :small="true"
            :disabled="!item.emUso"
            @click="item.emUso ? openDialogDetalharUsoDisciplina(item) : null"
          ></sigfoco-tooltip>
        </template>
        </v-data-table>
      </v-container>
      <VisualizarDisciplinaDialog
        v-if="dialogVisualizarDisciplina.visible"
        :visible="dialogVisualizarDisciplina.visible"
        :content="dialogVisualizarDisciplina.content"
        @onClose="dialogVisualizarDisciplina.close()"
      ></VisualizarDisciplinaDialog>
      <CadastrarEditarDisciplinaDialog
        :edit="dialogManterDisciplina.edit"
        :tipos="form.lists.tiposDeDisciplina"
        :visible="dialogManterDisciplina.visible"
        :content="dialogManterDisciplina.content"
        @onClose="dialogManterDisciplina.close()"
        @onSave="buscarDisciplina()"
      ></CadastrarEditarDisciplinaDialog>
      <DetalharUsoDisciplinaDialog
      :visible="dialogDetalharUsoDisciplina.visible"
      :content="dialogDetalharUsoDisciplina.content"
      @onClose="dialogDetalharUsoDisciplina.close()"
      ></DetalharUsoDisciplinaDialog>
    </div>
  </template>
  
  <script>
  import { Disciplina } from '~/commons/classes/disciplina';
  import { Dialog } from "~/commons/classes/dialog";
  import ManterDisciplinaService from '~/services/manter-disciplina.service';
  import VisualizarDisciplinaDialog from "./dialogs/VisualizarDisciplinaDialog.vue";
  import CadastrarEditarDisciplinaDialog from "./dialogs/CadastrarEditarDisciplinaDialog.vue";
  import DetalharUsoDisciplinaDialog from "./dialogs/DetalharUsoDisciplinaDialog.vue";
  export default {
    name: "ManterDisciplinaView",
    mixins: [ManterDisciplinaService],
    components: {
      VisualizarDisciplinaDialog,
      CadastrarEditarDisciplinaDialog,
      DetalharUsoDisciplinaDialog
    },
    data: () => ({
      dialogManterDisciplina: Dialog.Build(),
      dialogVisualizarDisciplina: Dialog.Build(),
      dialogDetalharUsoDisciplina: Dialog.Build(),
      form:{
        filters: {
          nomeDisciplina: null,
          tipoDisciplina: null,
          ativo: null,
        },
        lists: {
          tiposDeDisciplina: [],
          listDisciplinas: []
        }
      },
      headers: [
        { text: "Nome da Disciplina", align: "center", value: "nomeDisciplina" },
        { text: "Tipo de Disciplina", align: "center", value: "nomeTipoDisciplina" },
        { text: "Situação", align: "center", value: "ativo" },
        { text: "Ações", align: "center", value: "acoes", sortable: false },
        { text: "Em uso", align: "center", value: "emUso", sortable: false },

      ],
    }),
    methods: {
      buscarDisciplina() {
        this.$buscarDisciplina({ params: this.form.filters }).then(
          ({ data }) => this.form.lists.listDisciplinas = data.lista
        )
      },

      openDialogManterDisciplina(disciplina) {
        disciplina
          ? this.$visualizarDisciplina(disciplina.id).then(
            ({ data }) => this.dialogManterDisciplina.open(new Disciplina(data.resposta), true))
          : this.dialogManterDisciplina.open(Disciplina.Build());
      },
      openDialogVisualizarDisciplina(disciplina) {
        this.$visualizarDisciplina(disciplina.id).then(
          ({ data }) => this.dialogVisualizarDisciplina.open(new Disciplina(data.resposta))
        );
      },

      exclusaoDisciplina(disciplina) {
        this.$swal({
          text: `Deseja confirmar a exclusão da Disciplina?`,
          type: "error",
          showCancelButton: true,
          confirmButtonText: `Confirmar`,
          cancelButtonText: `Cancelar`,
        }).then(() => {
          if(disciplina.emUso) {
            this.mostrarModalEmUso(disciplina);
          }else {
          this.$excluirDisciplina(disciplina.id).then(
            ({ data }) => {
              this.$notifySuccess(data.mensagem);
              this.buscarDisciplina();
            });
          }
        });
      },
      alterarStatusDisciplina(disciplina) {
        this.$swal({
          text: `Deseja ${ disciplina.ativo ? "inativar " : "ativar" } a Disciplina?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: `Confirmar`,
          cancelButtonText: `Cancelar`,
        }).then(() => {
          if(disciplina.ativo && disciplina.emUso) {
            this.mostrarModalEmUso(disciplina);
          } else {
          this.$inativarAtivarDisciplina(disciplina.id).then(
            ({ data }) => {
              this.$notifySuccess(data.mensagem);
              this.buscarDisciplina();
            });
          }
        });
      },
      mostrarModalEmUso(item) {
        const qtd = item.quantidadeEmUso;
        this.$swal({
          text: `O registro não pode ser inativado ou excluído, pois está em uso em ${qtd} funcionalidade(s).`,
          type: "warning",
          confirmButtonText: "OK",
        });
      },
      openDialogDetalharUsoDisciplina(disciplina) {
        this.$detalharUsoDisciplina(disciplina).then(
          ({ data }) => (this.dialogDetalharUsoDisciplina.open(data.resposta))
        );
      },
      resetForm() {
        this.$resetForm();
        this.form.lists.listDisciplinas = [];
        this.form.filters.ativo = null;
      },
    },
    mounted() {
      this.$buscarTipoDeDisciplina().then(({ data }) => {
        this.form.lists.tiposDeDisciplina = data.lista;
      });
    }
  }
  </script>